const ACCESS_STORAGE_KEY = 'flux_prompt_sample_access_key';

const PRODUCTION_API_PATH = '/enterprise-makeup-api/api/nse-celebration';
const LEGACY_API_PATH = '/enterprise-makeup-api/api/nse-caricature';
const DEV_MAKEUP_PORT = '5014';

export function getStoredAccessKey() {
  try {
    return String(sessionStorage.getItem(ACCESS_STORAGE_KEY) || '').trim();
  } catch {
    return '';
  }
}

export function setStoredAccessKey(key) {
  try {
    sessionStorage.setItem(ACCESS_STORAGE_KEY, String(key || '').trim());
  } catch {
    // ignore
  }
}

export function clearStoredAccessKey() {
  try {
    sessionStorage.removeItem(ACCESS_STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function getNseCaricatureApiBaseUrl() {
  const override =
    process.env.REACT_APP_NSE_CARICATURE_API_URL ||
    process.env.REACT_APP_FLUX_REFERENCE_TRANSFER_API_URL;
  if (override) return String(override).replace(/\/$/, '');

  if (typeof window !== 'undefined' && window.location) {
    const { origin, hostname, port } = window.location;
    const isLocal =
      hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
    if (isLocal && (port === '3000' || port === '')) {
      return `${origin}/enterprise-makeup-api/api/nse-celebration`;
    }
    if (!isLocal) {
      return `${origin}${PRODUCTION_API_PATH}`;
    }
    return `http://localhost:${DEV_MAKEUP_PORT}/api/nse-celebration`;
  }
  return `http://localhost:${DEV_MAKEUP_PORT}/api/nse-celebration`;
}

function sampleHeaders(extra = {}) {
  const key = getStoredAccessKey();
  return {
    ...extra,
    ...(key ? { 'X-Flux-Prompt-Sample-Key': key } : {}),
  };
}

async function parseJson(res) {
  return res.json().catch(() => ({}));
}

export async function fetchNseCaricatureBuildInfo() {
  const res = await fetch(`${getNseCaricatureApiBaseUrl()}/build-info`);
  return parseJson(res);
}

export async function verifyNseCaricatureAccess(accessKey) {
  const res = await fetch(`${getNseCaricatureApiBaseUrl()}/verify-access`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ access_key: accessKey }),
  });
  const data = await parseJson(res);
  if (!res.ok || data?.success === false) {
    const err = new Error(data?.error || data?.code || `Request failed (${res.status})`);
    err.code = data?.code;
    throw err;
  }
  setStoredAccessKey(accessKey);
  return data;
}

export async function saveNseFrame({ background, alpha }) {
  const body = {};
  if (background) body.background = background;
  if (alpha) body.alpha = alpha;
  const res = await fetch(`${getNseCaricatureApiBaseUrl()}/frame`, {
    method: 'POST',
    headers: sampleHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok || data?.success === false) {
    const err = new Error(data?.error || data?.code || `Request failed (${res.status})`);
    err.code = data?.code;
    throw err;
  }
  return data;
}

export function nseFrameUrl(kind) {
  return `${getNseCaricatureApiBaseUrl()}/frame/${kind}`;
}

export async function generateNseCaricature({ image, prompt, seed, steps, guidance }) {
  const body = { image, prompt: prompt || '' };
  if (seed != null) body.seed = seed;
  if (steps != null) body.steps = steps;
  if (guidance != null) body.guidance = guidance;
  const res = await fetch(`${getNseCaricatureApiBaseUrl()}/generate`, {
    method: 'POST',
    headers: sampleHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok || data?.success === false) {
    const err = new Error(data?.error || data?.code || `Request failed (${res.status})`);
    err.code = data?.code;
    throw err;
  }
  return data;
}
